module.exports = __webpack_public_path__ + "img/submit-bg.832f32b.png";